import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import { useContext, useState, useEffect } from "react";
import { apiGetProductInfo } from "Root/api/apiCheckout";
import { useHistory } from "react-router-dom";
import { NavBar, HeadingBlock, Loading, AccordeonItem, Product, GainfulButton, } from "CheckoutComponents";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import { sumObjVals } from "Helpers/util";
import updateFlavors from "CheckoutComponents/Checkout/helpers/updateFlavors";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { sendPageViewToGA } from "Root/checkout/utils/ga4";
import StickyBottom from "../StickyBottom";
import { useFlavors } from "../Checkout/hooks";
import styles from "./styles.module.css";
import posthog from "posthog-js";
import { useDispatch } from "react-redux";
import { updateUserCart } from "Root/checkout/redux/slices/checkoutUserCartSlice";
import { setIsUpdatingCart } from "Root/checkout/redux/slices/checkoutComponentSlice";
import { useCart } from "@shopify/hydrogen-react";
import { proteinMap, shopifyFlavorBoostsMap, shopifyProductMap, } from "Root/shopify/client";
import { nanoid } from "nanoid";
const promotexts = {
    protein: "All of Gainful's protein blends are unflavored, so you can flavor every scoop of protein however you like, free of charge. Each Flavor Boost comes with 7 single-serving packets.",
    hydration: "Hydration is 100% plant-based, sweetened with natural stevia, and contains no artificial ingredients.",
    preworkout: "Pre-Workout is 100% vegan, sweetened with natural stevia, and contains no artificial flavors.",
    greens: "Gainful Greens are 100% plant-based and non-GMO, sweetened with natural stevia, and  free from artificial flavors, dyes, sweeteners, sugar alcohols. Only the cleanest ingredients!",
};
export const isInCart = (itemname, cart) => {
    const res = cart.findIndex((item) => item.item_type === itemname);
    return res > -1 ? res : null;
};
const productFlavorsChosenCount = (flavors) => {
    const countObj = Object.fromEntries(flavors.map(({ short_name, count }) => [short_name, count]));
    return sumObjVals(countObj);
};
function generateUUIDv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        let r = (Math.random() * 16) | 0;
        let v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export default function PersonalizationsPage() {
    const history = useHistory();
    const isMobile = useScreenWidth() < 900;
    const [showProtein, setShowProtein] = useState(true);
    const [showPreworkout, setShowPreworkout] = useState(true);
    const [showHydration, setShowHydration] = useState(true);
    const [showGreen, setShowGreen] = useState(true);
    const [proteinNextItem, setProteinNextItem] = useState("hydration");
    const [hydrationNextItem, setHydrationNextItem] = useState("preworkout");
    const [showBottomSticky, setShowBottomSticky] = useState(false);
    const [internalLoading, setInternalLoading] = useState(false);
    const [hasClearedCart, setHasClearedCart] = useState(false);
    // state that all items are validated - or not all
    const [isAllValidated, setIsAllvalidated] = useState(true);
    const dispatch = useDispatch();
    const [addonAttributes, setAddonAttributes] = useState(null);
    const { cart, userCart, error_message, updatingItems, setUserCart, setUpdatingFlavors, checkoutPages, setUserName, bannerData, sellingPlan, shopifyProducts, sellingPlanOptions, } = useContext(CheckoutContext);
    useEffect(() => {
        if (userCart.length < 1)
            return;
        // Logic which accordeon should be open depending on user cart
        const proteinInCart = isInCart("protein", userCart) !== null;
        const hydrationInCart = isInCart("hydration", userCart) !== null;
        const preworkoutInCart = isInCart("preworkout", userCart) !== null;
        const greensInCart = isInCart("greens", userCart) !== null;
        if (!proteinInCart && !hydrationInCart && !greensInCart) {
            setShowPreworkout(true);
            // setShowBottomSticky(true);
        }
        else if (!proteinInCart) {
            if (greensInCart) {
                setShowGreen(true);
                setShowPreworkout(false);
                setShowHydration(false);
            }
            else {
                setShowHydration(true);
                setShowPreworkout(false);
            }
        }
        else {
            setShowGreen(false);
            setShowPreworkout(false);
            setShowHydration(false);
        }
        if (!proteinInCart && !hydrationInCart) {
            setShowPreworkout(true);
            // setShowBottomSticky(true);
        }
        else if (!proteinInCart) {
            setShowHydration(true);
            setShowPreworkout(false);
        }
        else if (history.location.hash === "#hydration") {
            setShowHydration(true);
            setShowPreworkout(false);
            setShowProtein(false);
            window.scrollTo({
                top: isMobile ? 300 : 400,
                behavior: "smooth",
            });
        }
        else if (history.location.hash === "#preworkout") {
            setShowPreworkout(true);
            setShowProtein(false);
            setShowHydration(false);
            window.scrollTo({
                top: isMobile ? 300 : 400,
                behavior: "smooth",
            });
        }
        else {
            setShowPreworkout(false);
            setShowHydration(false);
        }
        // Set dynamic buttons text
        const nextItemText = preworkoutInCart ? "preworkout" : "last";
        setProteinNextItem(greensInCart ? "greens" : hydrationInCart ? "hydration" : nextItemText);
        setHydrationNextItem(preworkoutInCart ? "preworkout" : "last");
    }, [userCart]);
    // Add logic for flavor choose work
    const { addFlavor, addProteinFlavor, proteinFlavors, hydrationFlavors, preworkoutFlavors, flavorLimits, updateAttribute, chooseHydrationFlavorsScreen, choosePreworkoutFlavorsScreen, chooseProteinFlavorsScreen, greensFlavors, } = useFlavors({ error_message, addonAttributes, setAddonAttributes });
    // additional product information
    const [name, setName] = useState("");
    // Check if these products are in cart
    // These return the indices in the cart
    const hasprotein = isInCart("protein", userCart);
    const hashydration = isInCart("hydration", userCart);
    const haspreworkout = isInCart("preworkout", userCart);
    const hasGreens = isInCart("greens", userCart);
    // These return booleans
    const proteinIsInCart = isInCart("protein", userCart) !== null;
    const hydrationIsInCart = isInCart("hydration", userCart) !== null;
    const preworkoutIsInCart = isInCart("preworkout", userCart) !== null;
    const greensIsInCart = isInCart("greens", userCart) !== null;
    const [finished, setFinished] = useState(false);
    const { linesAdd, checkoutUrl, cartCreate, linesRemove, lines, status } = useCart();
    useEffect(() => {
        const getProductInfo = async () => {
            const data = (await apiGetProductInfo("all"));
            if (data) {
                setUserName(data?.protein.name);
                setName(data.protein.name);
            }
        };
        getProductInfo();
        window.scrollTo(0, 0);
        sendPageViewToGA("personalizations");
        posthog?.capture("$pageview");
        cartCreate({});
    }, []); // Only run once
    useEffect(() => {
        if (lines.length !== 0 && !hasClearedCart && !internalLoading) {
            linesRemove(lines.map((item) => item.id));
            setHasClearedCart(true);
        }
    }, [lines]);
    // Each product is validated separately
    const validateProtein = (showError = true) => {
        if (!proteinIsInCart) {
            // if they don't have protein then this will always be true
            return true;
        }
        let isValid = true;
        const proteinFlavorCount = productFlavorsChosenCount(proteinFlavors);
        if (proteinFlavorCount < flavorLimits.protein && cart.protein > 0) {
            if (showError) {
                error_message("*Please make flavor selections before proceeding to checkout.");
            }
            isValid = false;
        }
        return isValid;
    };
    const validateHydration = (showError = true) => {
        if (!hydrationIsInCart) {
            // if they don't have hydration then this will always be true
            return true;
        }
        let isValid = true;
        const hydrationFlavorCount = productFlavorsChosenCount(hydrationFlavors);
        if (hydrationFlavorCount < flavorLimits.hydration && cart.hydration > 0) {
            if (showError) {
                error_message("*Please make flavor selections before proceeding to checkout.");
            }
            isValid = false;
        }
        return isValid;
    };
    const validateGreens = (showError = true) => {
        if (!greensIsInCart) {
            // if they don't have gr then this will always be true
            return true;
        }
        let isValid = true;
        const greensFlavorCount = productFlavorsChosenCount(greensFlavors);
        if (greensFlavorCount < flavorLimits.greens && cart.greens > 0) {
            if (showError) {
                error_message("*Please make flavor selections before proceeding to checkout.");
            }
            isValid = false;
        }
        return isValid;
    };
    const validatePreworkout = (showError = true) => {
        if (!preworkoutIsInCart) {
            // if they don't have preworkout then this will always be true
            return true;
        }
        let isValid = true;
        const preworkoutFlavorCountObj = Object.fromEntries(preworkoutFlavors.map(({ short_name, count }) => [short_name, count]));
        const preworkoutFlavorCount = sumObjVals(preworkoutFlavorCountObj);
        if (preworkoutFlavorCount < flavorLimits.preworkout &&
            cart.preworkout > 0) {
            if (showError) {
                error_message("*Please make flavor selections before proceeding to checkout.");
            }
            isValid = false;
        }
        return isValid;
    };
    useEffect(() => {
        if (flavorLimits && Object.keys(flavorLimits).length !== 0) {
            // If all items in cart have full flavors, show sticky bottom immediately
            if (validateProtein(false) &&
                validatePreworkout(false) &&
                validateHydration(false) &&
                validateGreens(false)) {
                setShowBottomSticky(true);
            }
        }
    }, [flavorLimits]);
    // Callback that all flavors should update: run request
    const updateAllFlavors = () => updateFlavors({
        cart,
        proteinFlavors,
        greensFlavors,
        error_message,
        preworkoutFlavors,
        hydrationFlavors,
        flavorLimits,
        addonAttributes,
        setUserCart: async (data) => {
            await dispatch(setIsUpdatingCart(false));
            setUserCart(data);
            dispatch(updateUserCart(data));
        },
        setUpdatingFlavors,
    });
    const getShopifyIdByInternalSku = (sku) => {
        return (shopifyProducts.find((item) => item.sku?.toLowerCase() === sku?.toLowerCase())?.id ||
            shopifyProducts.find((item) => item.productType?.toLowerCase() === sku?.toLowerCase())?.id);
    };
    const getProteinShopifyIdBySku = (sku, qty) => {
        return shopifyProducts.find((item) => item.sku === sku &&
            item.options.find((option) => option.name.indexOf("bag") !== -1 &&
                option.value.split("bag").at(0) === qty.toString()))?.id;
    };
    // go to next page
    const goNext = async () => {
        if (addonAttributes !== null) {
            setInternalLoading(true);
            setUpdatingFlavors(true);
            // dispatch(setGlobalLoading(true));
            const isValid = await updateAllFlavors(userCart);
            dispatch(setIsUpdatingCart(true));
            const selectedPlans = sellingPlan;
            if (isValid) {
                try {
                    const { userCart: updatedUserCart } = isValid;
                    const itemsToAdd = updatedUserCart
                        .filter((item) => item.item_type !== "protein")
                        .map((item) => {
                        const obj = {
                            merchandiseId: getShopifyIdByInternalSku(item.sku) ||
                                `gid://shopify/ProductVariant/${shopifyProductMap[item.sku]}`,
                            quantity: item.quantity,
                        };
                        if (selectedPlans &&
                            selectedPlans[item.item_type] &&
                            selectedPlans[item.item_type]?.external_plan_id !== "otb") {
                            obj.sellingPlanId =
                                "gid://shopify/SellingPlan/" +
                                    selectedPlans[item.item_type].external_plan_id;
                        }
                        return obj;
                    });
                    if (proteinIsInCart) {
                        const protein = JSON.parse(JSON.stringify(updatedUserCart)).find((item) => item.item_type === "protein");
                        const proteinNanoID = nanoid();
                        const proteinData = {
                            merchandiseId: getProteinShopifyIdBySku(protein.sku, protein.quantity) ||
                                `gid://shopify/ProductVariant/${proteinMap[protein.sku].qtyVariants[protein.quantity]}`,
                            quantity: 1,
                            attributes: [{ key: "_p_id", value: proteinNanoID }],
                        };
                        if (selectedPlans &&
                            selectedPlans["protein"]?.external_plan_id !== "otb" &&
                            selectedPlans["protein"]?.subscription_preferences
                                ?.charge_interval_frequency) {
                            if (protein.sku === "nm") {
                                const nmSellingPlan = sellingPlanOptions["nm"]?.find((plan) => plan.subscription_preferences?.charge_interval_frequency ===
                                    selectedPlans["protein"].subscription_preferences
                                        ?.charge_interval_frequency);
                                proteinData.sellingPlanId =
                                    "gid://shopify/SellingPlan/" +
                                        nmSellingPlan?.external_plan_id;
                            }
                            else {
                                proteinData.sellingPlanId =
                                    "gid://shopify/SellingPlan/" +
                                        selectedPlans["protein"].external_plan_id;
                            }
                        }
                        const flavors = protein.bags_info[0].selected_flavors.map((item) => {
                            const flavorObj = {
                                merchandiseId: getShopifyIdByInternalSku(item.short_name) ||
                                    `gid://shopify/ProductVariant/${shopifyFlavorBoostsMap[item.short_name].variant}`,
                                quantity: item.count,
                                attributes: [
                                    // { key: "_p_id", value: proteinNanoID },
                                    { key: "_p_id_link", value: proteinNanoID },
                                ],
                            };
                            if (selectedPlans &&
                                selectedPlans["protein"] &&
                                selectedPlans["protein"].external_plan_id !== "otb") {
                                const fbSellingPlanId = sellingPlanOptions[item.short_name]?.find((plan) => plan.subscription_preferences
                                    ?.charge_interval_frequency ===
                                    selectedPlans["protein"].subscription_preferences
                                        ?.charge_interval_frequency);
                                flavorObj.sellingPlanId =
                                    "gid://shopify/SellingPlan/" +
                                        fbSellingPlanId?.external_plan_id;
                            }
                            return flavorObj;
                        });
                        itemsToAdd.push(proteinData);
                        itemsToAdd.push(...flavors);
                    }
                    linesAdd(itemsToAdd);
                    setFinished(true);
                }
                catch (e) {
                    console.log(e);
                }
            }
            else {
                setInternalLoading(false);
            }
        }
    };
    useEffect(() => {
        if (finished && status !== "updating") {
            setTimeout(() => {
                setInternalLoading(false);
                window.location.href = checkoutUrl;
            }, 500);
        }
    }, [finished, status]);
    const saveFlavors = () => {
        // do not show error message if user go back
        // if (addonAttributes !== null && index > oldIndex) {
        //   setUpdatingFlavors(true);
        //   updateAllFlavors();
        // }
    };
    // run this when userCart updates and when user chooses new flavors
    useEffect(() => {
        const validProtein = hasprotein !== null
            ? productFlavorsChosenCount(proteinFlavors) ===
                flavorLimits[userCart[hasprotein]?.item_type]
            : true;
        const validGreens = hasGreens !== null
            ? productFlavorsChosenCount(greensFlavors) ===
                flavorLimits[userCart[hasGreens]?.item_type]
            : true;
        const validHydration = hashydration !== null
            ? productFlavorsChosenCount(hydrationFlavors) ===
                flavorLimits[userCart[hashydration]?.item_type]
            : true;
        const validPreworkout = haspreworkout !== null
            ? productFlavorsChosenCount(preworkoutFlavors) ===
                flavorLimits[userCart[haspreworkout]?.item_type]
            : true;
        const allValid = validPreworkout && validProtein && validHydration;
        if (allValid && !isAllValidated) {
            setIsAllvalidated(true);
        }
        else if (!allValid && isAllValidated) {
            setIsAllvalidated(false);
        }
        // if(allValid) updateAllFlavors();
        if ((flavorLimits &&
            Object.keys(flavorLimits).length !== 0 &&
            ((preworkoutIsInCart && validPreworkout) ||
                (!preworkoutIsInCart && hydrationIsInCart && validHydration) ||
                (!preworkoutIsInCart && !hydrationIsInCart && validGreens))) ||
            (!preworkoutIsInCart &&
                !hydrationIsInCart &&
                !greensIsInCart &&
                validProtein)) {
            setShowBottomSticky(true);
        }
    }, [
        proteinFlavors,
        hydrationFlavors,
        preworkoutFlavors,
        userCart,
        flavorLimits,
    ]);
    // Accordeon callbacks
    const hideProteinBlock = () => {
        setShowProtein(false);
    };
    const hideHydrationBlock = () => {
        setShowHydration(false);
    };
    const hideGreenBlock = () => {
        setShowGreen(false);
    };
    const showPreworkoutBlock = () => {
        if (!showPreworkout) {
            const proteinValidated = validateProtein();
            const hydrationValidated = validateHydration();
            if (hydrationValidated && proteinValidated) {
                setShowPreworkout(true);
                hideProteinBlock();
                hideHydrationBlock();
                hideGreenBlock();
                // setShowBottomSticky(true);
                const pwCard = document.getElementById("preworkout_card");
                const blockCoordinates = pwCard.getBoundingClientRect();
                window.scrollTo({
                    top: window.scrollY + blockCoordinates.top,
                    behavior: "smooth",
                });
            }
        }
        else if (validatePreworkout()) {
            setShowPreworkout(false);
        }
    };
    const showHydrationBlock = () => {
        if (!showHydration) {
            const proteinValidated = validateProtein();
            if (proteinValidated) {
                hideProteinBlock();
                hideGreenBlock();
                setShowHydration(true);
                setShowPreworkout(false);
                if (!preworkoutIsInCart) {
                    setShowBottomSticky(true);
                }
                if (preworkoutIsInCart && !validatePreworkout(false)) {
                    setShowBottomSticky(false);
                }
                const hydrationCard = document.getElementById("hydration_card");
                const blockCoordinates = hydrationCard.getBoundingClientRect();
                window.scrollTo({
                    top: window.scrollY + blockCoordinates.top,
                    behavior: "smooth",
                });
            }
        }
        else if (validateHydration()) {
            if (preworkoutIsInCart) {
                showPreworkoutBlock();
            }
            else {
                setShowHydration(false);
            }
        }
    };
    const showProteinBlock = () => {
        if (!showProtein) {
            // show protein and close other items
            setShowProtein(true);
            setShowHydration(false);
            setShowPreworkout(false);
            setShowGreen(false);
            if ((preworkoutIsInCart && !validatePreworkout(false)) ||
                (!preworkoutIsInCart && hydrationIsInCart && !validateHydration(false))) {
                setShowBottomSticky(false);
            }
        }
        else if (validateProtein()) {
            if (hydrationIsInCart) {
                showHydrationBlock();
            }
            else if (preworkoutIsInCart) {
                showPreworkoutBlock();
            }
            else if (hasGreens) {
                showGreenBlock();
            }
        }
    };
    const showGreenBlock = () => {
        if (!showGreen) {
            const proteinValidated = validateProtein();
            if (proteinValidated) {
                hideProteinBlock();
                setShowGreen(true);
                setShowHydration(false);
                setShowPreworkout(false);
                const greenCard = document.getElementById("greens_card");
                const blockCoordinates = greenCard.getBoundingClientRect();
                window.scrollTo({
                    top: window.scrollY + blockCoordinates.top,
                    behavior: "smooth",
                });
            }
        }
        else {
            setShowGreen(false);
        }
    };
    const getImageUrl = (cartItem) => {
        if ((cartItem.quantity === 1 || cartItem.bags_info.length === 1) &&
            ["preworkout", "hydration"].includes(cartItem.item_type)) {
            const flavors = cartItem.item_type === "hydration"
                ? hydrationFlavors
                : preworkoutFlavors;
            const selectedFlavor = flavors
                .filter((item) => item.count)
                .map((item) => item.short_name);
            return (cartItem.available_flavors.find((item) => !!selectedFlavor.includes(item.short_name))?.product_image || cartItem.available_flavors[0].product_image);
        }
        return cartItem.checkout_image_url || cartItem.image_url;
    };
    return (_jsxs("div", { children: [_jsx(NavBar, { active: 3, cart: null, continue: addonAttributes !== null && goNext, onGoNext: saveFlavors, isBottomHidden: true, nextDisabled: !showBottomSticky || (!isAllValidated && addonAttributes !== null), bannerData: bannerData }), _jsxs("div", { className: styles.page, children: [_jsx("div", { className: styles.customizeContainer, children: _jsx(HeadingBlock, { title: "Customize Your System", subtitle: "Plant-Based  +  Naturally Sweetened  +  No artificial ingredients", isMainTitle: false }) }), _jsxs("div", { className: styles.accordeonscontainer, children: [userCart.length > 0 ? (_jsxs("div", { className: styles.mainpart, children: [hasprotein !== null ? (_jsx(AccordeonItem, { title: userCart[hasprotein].title.replace("Personalized ", ""), onClick: showProteinBlock, limittext: "Flavor Boosts", validlimit: productFlavorsChosenCount(proteinFlavors) ===
                                            flavorLimits[userCart[hasprotein].item_type], limit: productFlavorsChosenCount(proteinFlavors) !== undefined &&
                                            flavorLimits[userCart[hasprotein].item_type] !== undefined
                                            ? `(${productFlavorsChosenCount(proteinFlavors)}/${flavorLimits[userCart[hasprotein].item_type]})`
                                            : "", open: showProtein, children: _jsx("div", { className: `${styles.productcard} ${showProtein ? "" : styles.hidden}`, children: _jsx(Product, { image: userCart[hasprotein].checkout_image_url, row: true, title: "Protein", reversed: true, flavorsdesc: promotexts.protein, flavors: proteinFlavors, maxFlavors: flavorLimits.protein, shortName: userCart[hasprotein].item_type, addFlavor: addFlavor, addProteinFlavor: addProteinFlavor, fname: name, showMoreDetails: true, useCounter: true, isProteinChosen: chooseProteinFlavorsScreen, isHydrationChosen: chooseHydrationFlavorsScreen, isPreworkoutChosen: choosePreworkoutFlavorsScreen, updatingItems: updatingItems, editable: true, isBoost: false, isCarousel: false, nextbutton: preworkoutIsInCart ||
                                                    hydrationIsInCart ||
                                                    greensIsInCart ? (_jsx(GainfulButton, { onClick: greensIsInCart
                                                        ? showGreenBlock
                                                        : hydrationIsInCart
                                                            ? showHydrationBlock
                                                            : showPreworkoutBlock, text: `Continue to ${proteinNextItem}`, disabled: productFlavorsChosenCount(proteinFlavors) !==
                                                        flavorLimits[userCart[hasprotein].item_type], size: "w100" })) : null }) }) })) : null, hasGreens !== null ? (_jsx(AccordeonItem, { title: userCart[hasGreens].title.replace("Personalized ", ""), onClick: showGreenBlock, limittext: "Flavor", validlimit: productFlavorsChosenCount(greensFlavors) ===
                                            flavorLimits[userCart[hasGreens].item_type], limit: productFlavorsChosenCount(greensFlavors) !== undefined &&
                                            flavorLimits[userCart[hasGreens].item_type] !== undefined
                                            ? `(${productFlavorsChosenCount(greensFlavors)}/${flavorLimits[userCart[hasGreens].item_type]})`
                                            : "", open: showGreen, children: _jsx("div", { id: "greens_card", className: `${styles.productcard} ${showGreen ? "" : styles.hidden}`, children: _jsx(Product, { image: getImageUrl(userCart[hasGreens]), row: true, title: "Daily Performance Greens", reversed: true, flavorsdesc: promotexts[userCart[hasGreens].item_type], flavors: greensFlavors, maxFlavors: flavorLimits[userCart[hasGreens].item_type], shortName: userCart[hasGreens].item_type, addFlavor: addFlavor, fname: name, showMoreDetails: true, useCounter: false, isProteinChosen: chooseProteinFlavorsScreen, isHydrationChosen: chooseHydrationFlavorsScreen, isPreworkoutChosen: choosePreworkoutFlavorsScreen, updatingItems: updatingItems, attributes: addonAttributes == null
                                                    ? null
                                                    : addonAttributes[userCart[hasGreens].item_type], updateAttribute: updateAttribute, editable: true, isBoost: false, isCarousel: false, nextbutton: hydrationIsInCart || preworkoutIsInCart ? (_jsx(GainfulButton, { onClick: hydrationIsInCart
                                                        ? showHydrationBlock
                                                        : showPreworkoutBlock, text: `Continue to ${hydrationIsInCart ? "Hydration" : "Pre-Workout"}`, disabled: productFlavorsChosenCount(greensFlavors) !==
                                                        flavorLimits[userCart[hasGreens].item_type], size: "w100" })) : null }) }) })) : null, hashydration !== null ? (_jsx(AccordeonItem, { title: userCart[hashydration].title.replace("Personalized ", ""), onClick: showHydrationBlock, limittext: "Flavor + Personalization", validlimit: productFlavorsChosenCount(hydrationFlavors) ===
                                            flavorLimits[userCart[hashydration].item_type], limit: productFlavorsChosenCount(hydrationFlavors) !== undefined &&
                                            flavorLimits[userCart[hashydration].item_type] !== undefined
                                            ? `(${productFlavorsChosenCount(hydrationFlavors)}/${flavorLimits[userCart[hashydration].item_type]})`
                                            : "", open: showHydration, children: _jsx("div", { id: "hydration_card", className: `${styles.productcard} ${showHydration ? "" : styles.hidden}`, children: _jsx(Product, { image: getImageUrl(userCart[hashydration]), row: true, title: "Hydration", reversed: true, flavorsdesc: promotexts[userCart[hashydration].item_type], flavors: hydrationFlavors, maxFlavors: flavorLimits[userCart[hashydration].item_type], shortName: userCart[hashydration].item_type, addFlavor: addFlavor, fname: name, useCounter: false, isProteinChosen: chooseProteinFlavorsScreen, isHydrationChosen: chooseHydrationFlavorsScreen, isPreworkoutChosen: choosePreworkoutFlavorsScreen, updatingItems: updatingItems, showMoreDetails: true, attributes: addonAttributes === null
                                                    ? null
                                                    : addonAttributes[userCart[hashydration].item_type], updateAttribute: updateAttribute, editable: true, isBoost: false, isCarousel: false, imageVariants: userCart[hashydration].image_variants, nextbutton: preworkoutIsInCart ? (_jsx(GainfulButton, { onClick: showPreworkoutBlock, text: `Continue to ${hydrationNextItem}`, disabled: productFlavorsChosenCount(hydrationFlavors) !==
                                                        flavorLimits[userCart[hashydration].item_type], size: "w100" })) : null }) }) })) : null, haspreworkout !== null ? (_jsx(AccordeonItem, { title: userCart[haspreworkout].title.replace("Personalized ", ""), onClick: showPreworkoutBlock, limittext: "Flavor + Personalization", validlimit: productFlavorsChosenCount(preworkoutFlavors) ===
                                            flavorLimits[userCart[haspreworkout].item_type], limit: productFlavorsChosenCount(preworkoutFlavors) !==
                                            undefined &&
                                            flavorLimits[userCart[haspreworkout].item_type] !==
                                                undefined
                                            ? `(${productFlavorsChosenCount(preworkoutFlavors)}/${flavorLimits[userCart[haspreworkout].item_type]})`
                                            : "", open: showPreworkout, children: _jsx("div", { id: "preworkout_card", className: `${styles.productcard} ${showPreworkout ? "" : styles.hidden}`, children: _jsx(Product, { image: getImageUrl(userCart[haspreworkout]), row: true, title: "Pre-Workout", reversed: true, flavorsdesc: promotexts[userCart[haspreworkout].item_type], flavors: preworkoutFlavors, maxFlavors: flavorLimits[userCart[haspreworkout].item_type], shortName: userCart[haspreworkout].item_type, addFlavor: addFlavor, fname: name, showMoreDetails: true, useCounter: false, isProteinChosen: chooseProteinFlavorsScreen, isHydrationChosen: chooseHydrationFlavorsScreen, isPreworkoutChosen: choosePreworkoutFlavorsScreen, updatingItems: updatingItems, attributes: addonAttributes == null
                                                    ? null
                                                    : addonAttributes[userCart[haspreworkout].item_type], updateAttribute: updateAttribute, editable: true, isBoost: false, isCarousel: false }) }) })) : null] })) : (_jsxs("div", { className: styles.mainpart, children: [_jsx(Loading, {}), _jsx(Loading, {}), _jsx(Loading, {}), _jsx(Loading, {})] })), (showBottomSticky || isAllValidated) && (_jsx(StickyBottom, { text: "Proceed to checkout", handleClick: goNext, buttonDisabled: (!isAllValidated && addonAttributes !== null) || internalLoading }))] })] })] }));
}
